<!-- legal-documentation.component.html -->
<app-unauth-navbar></app-unauth-navbar>
<div class="container-lg" style="padding-top: 70px">
  <div class="row">
    <div class="col-md-3 col-12 mb-3 d-grid justify-content-center">
      <p class="document">Legal Documentation</p>
      <br />
      <button
        class="bttn"
        routerLink="/legal-documentation/terms-of-service"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a class="first-link">
          <img
            src="/assets/img/Document Text.png"
            alt=""
            class="documentimage"
          />&nbsp;&nbsp;&nbsp; Terms of use
        </a>
      </button>
      <br />
      <button
        class="bttn"
        routerLink="/legal-documentation/privacy-policy"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a class="second-link">
          <img
            src="/assets/img/Shield Check.png"
            alt=""
            class="documentimage"
          />&nbsp;&nbsp;&nbsp; Privacy Policy
        </a>
      </button>
    </div>
    <div class="col-md-9">
      <div class="card-shadow d-block mx-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
    <section style="background-color: var(--theme-color1)">
      <div class="container p-5">
        <app-landing-page-footer></app-landing-page-footer>
      </div>
    </section>
  </div>
</div>
